import './style.css';
import { setBasePath } from '@shoelace-style/shoelace/dist/utilities/base-path.js';
import '@shoelace-style/shoelace/dist/components/button/button.js';
import '@shoelace-style/shoelace/dist/components/card/card.js';
import '@shoelace-style/shoelace/dist/components/icon/icon.js';
import '@shoelace-style/shoelace/dist/components/icon-button/icon-button.js';
import '@shoelace-style/shoelace/dist/components/input/input.js';
import '@shoelace-style/shoelace/dist/components/textarea/textarea.js';

import { renderHome } from './pages/Home';
import { renderGamesPage } from './pages/GamesPage';
import { renderMusicsPage } from './pages/MusicsPage';
import { renderFilmsPage } from './pages/FilmsPage';
import { renderDevsPage } from './pages/DevsPage';
import { renderAbout } from './pages/About';
import { renderContact } from './pages/Contact';

// Set Shoelace base path for icons and assets
setBasePath('https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.12.0/cdn/');

// Router function
function router() {
  const hash = window.location.hash.slice(1).toLowerCase() || 'home';
  const app = document.getElementById('app');
  
  if (!app) return;
  
  switch(hash) {
    case 'home':
      app.innerHTML = renderHome();
      break;
    case 'games':
      app.innerHTML = renderGamesPage();
      break;
    case 'musics':
    case 'music':
      app.innerHTML = renderMusicsPage();
      break;
    case 'films':
    case 'film':
      app.innerHTML = renderFilmsPage();
      break;
    case 'devs':
    case 'dev':
      app.innerHTML = renderDevsPage();
      break;
    case 'about':
      app.innerHTML = renderAbout();
      break;
    case 'contact':
      app.innerHTML = renderContact();
      break;
    default:
      app.innerHTML = renderHome();
  }
  
  // Scroll to top on page change
  window.scrollTo(0, 0);
}

// Initialize app
document.addEventListener('DOMContentLoaded', router);
window.addEventListener('hashchange', router);
